module.exports = __webpack_public_path__ + "static/media/CreateBrandspaceTop.884e3cb1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OnBoarding/Steps/assets/CreateBrandspaceTop.gif
// module id = 907
// module chunks = 0